/*
* Definition Suchzeile:
* UniqueID der Suchzeile
* TrafficLightId: Ampelnummer, die 0 steht für die Produktionsfelder!
* */

/*
* Data = SearchValue =
* { fieldName: "TYPE_OF_RIGHTS", operator: "EQUALS", searchValueList: ["wert1", "wert2"] }
*
 */
import WizardProfileService from "../../services/wizardprofile.service";
import AvailSearchService from '@/services/availsearch.service';
import ContractService from '@/services/contract.service';
import OptionsService from '@/services/option.service';
import Vue from 'vue';
import {objectToFlattenObject} from "@/services/util.service";
import _ from "lodash";

const SEARCH_PROFILE_FIELDNAME = 'SEARCH_PROFILE';

const state = {
  uniqueId: 100,
  searchRowList: [],
  trafficLights: [],
  searchProfiles: [],
  activeProfile: null,
  multiAvailFilters: {},

  searching: false,
  multiAvailList: [],
  licences: [],
  contracts: [],
  options: [],
  availDetails: []

};

const mutations = {
  reset(state) {
    state.uniqueId = 0;
    let tlId = ++state.uniqueId;
    state.searchRowList = [
      {
        uniqueId: ++state.uniqueId,
        trafficLightId: 0,
        id: 1,
        searchField: "originalTitle",
        searchOperator: "CONTAINS",
        data: [""]
      },
      {
        uniqueId: ++state.uniqueId,
        trafficLightId: tlId,
        id: 3,
        searchField: "TYPE_OF_RIGHTS",
        searchOperator: "EQUALS",
        data: [""],
        fixed: true
      },
      {
        uniqueId: ++state.uniqueId,
        trafficLightId: tlId,
        id: 4,
        searchField: "LICENCE_TERRITORIES",
        searchOperator: "EQUALS",
        data: [""],
        fixed: true
      },
      {
        uniqueId: ++state.uniqueId,
        trafficLightId: tlId,
        id: 5,
        searchField: "EXCLUSIVE",
        searchOperator: "BOOLEAN",
        data: [""],
        fixed: true
      }
    ];
    state.trafficLights = [
      // { uniqueId: tlId, type: 'OPTIONAL' }
      {uniqueId: tlId, type: 'NEEDED'}
    ];
  },
  addProductionSearch(state, searchRow) {
    state.uniqueId++;
    searchRow['uniqueId'] = state.uniqueId;
    state.searchRowList.push(searchRow);
  },
  removeSearchRow(state, uniqueId) {
    let searchRow = state.searchRowList.filter(value => value.uniqueId === uniqueId);

    for (let row of searchRow) {
      let index = state.searchRowList.indexOf(row);
      if (index !== -1) state.searchRowList.splice(index, 1);
    }
  },
  setFieldForSearchRow(state, call) {
    let searchRow = state.searchRowList.filter(value => value.uniqueId === call.uniqueId);
    searchRow[0].searchField = call.field;
  },
  setOperatorForSearchRow(state, call) {
    let searchRow = state.searchRowList.filter(value => value.uniqueId === call.uniqueId);
    searchRow[0].searchOperator = call.operator;
    if (call.operator === "IS_EMPTY" || call.operator === "IS_NOT_EMPTY") {
      searchRow[0].data = [''];
    }
  },
  setMultiAvailFilters(state, multiAvailFilters) {
    state.multiAvailFilters = multiAvailFilters;
  },
  addTrafficLight(state) {
    let id = state.uniqueId++;
    state.trafficLights.push({
      uniqueId: id, type: 'OPTIONAL'
    });

    state.searchRowList.push({
      uniqueId: ++state.uniqueId,
      trafficLightId: id,
      searchField: "TYPE_OF_RIGHTS",
      searchOperator: "EQUALS",
      data: [""],
      fixed: true
    });
    state.searchRowList.push({
      uniqueId: ++state.uniqueId,
      trafficLightId: id,
      searchField: "LICENCE_TERRITORIES",
      searchOperator: "EQUALS",
      data: [""],
      fixed: true
    });
    state.searchRowList.push({
      uniqueId: ++state.uniqueId,
      trafficLightId: id,
      searchField: "EXCLUSIVE",
      searchOperator: "BOOLEAN",
      data: [""],
      fixed: true
    })
  },
  setTrafficLightType(state, call) {
    let tl = state.trafficLights.filter(value => value.uniqueId === call.uniqueId)[0];
    tl.type = call.type;
  },

  setData(state, call) {
    let searchRow = state.searchRowList.filter(value => value.uniqueId === call.uniqueId);

    searchRow[0].data = call.data;
  },
  removeTrafficLight(state, uniqueId) {
    state.searchRowList = state.searchRowList.filter(value => value.uniqueId !== uniqueId);
    state.trafficLights = state.trafficLights.filter(value => value.uniqueId !== uniqueId);
  },
  cloneTrafficLight(state, uniqueId) {
    let tlList = state.trafficLights.filter(value => value.uniqueId === uniqueId);
    let source = tlList[0];
    let tl = {...source};
    tl.uniqueId = ++state.uniqueId;
    state.trafficLights.push(tl);

    let rows = state.searchRowList.filter(value => value.trafficLightId === uniqueId);
    for (let row of rows) {
      let newRow = {...row};
      newRow.uniqueId = ++state.uniqueId;
      newRow.trafficLightId = tl.uniqueId;
      state.searchRowList.push(newRow);
    }
  },

  addSearchProfile(state, searchProfile) {
    state.searchProfiles.push(searchProfile);
    state.activeProfile = searchProfile;
  },
  setProfiles(state, profileList) {
    state.searchProfiles = profileList;
  },
  clearStore(state) {
    state.uniqueId = null;
    state.trafficLights = [];
    state.searchRowList = [];
  },

  setStoreData(state, storeData) {
    state.trafficLights = storeData.trafficLights;
    state.searchRowList = storeData.searchRowList;
    state.uniqueId = storeData.uniqueId;
    state.activeProfile = storeData.searchProfile;
  },
  removeProfile(state, profileId) {
    state.searchProfiles = state.searchProfiles.filter(value => value.id !== profileId);
  },
  publishProfile(state, profileId) {
    let profile = state.searchProfiles.filter(value => value.id === profileId)[0];
    profile['published'] = true;
  },
  dePublishProfile(state, profileId) {
    let profile = state.searchProfiles.filter(value => value.id === profileId)[0];
    profile['published'] = false;
  },

  startSearching(state) {
    state.searching = true;
  },
  resetSearchData(state) {
    state.multiAvailList = [];
    state.licences = [];
    state.contracts = [];
    state.availDetails = [];
  },
  finishSearching(state) {
    state.searching = false;
  },
  setMultiAvailList(state, list) {
    state.multiAvailList = list;
  },
  setLicences(state, licenceList) {
    state.licences = licenceList;
  },
  setContracts(state, contracts) {
    state.contracts = contracts;
  },
  setOptions(state, options) {
    state.options = options;
  },
  setAvailDetails(state, availDetails) {
    state.availDetails = availDetails;
  }

};

const getters = {
  getAll: (state) => {
    return state.searchRowList;
  },
  getAsSearchRequest: (state) => {
    let productionSearchList = state.searchRowList.filter(value => {
      return value.trafficLightId === 0;
    });
    let availBaseSearchList = [];
    for (let row of productionSearchList) {
      availBaseSearchList.push(
        {fieldName: row.searchField, operator: row.searchOperator, searchValueList: row.data}
      )
    }

    let availSearch = [];
    for (let tl of state.trafficLights) {
      let licenceSearchList = state.searchRowList.filter(value => {
        return value.trafficLightId === tl.uniqueId;
      });

      let availBaseSearchList = [];
      for (let row of licenceSearchList) {

        availBaseSearchList.push(
            {fieldName: row.searchField, operator: row.searchOperator, searchValueList: row.data}
        )
      }

      availSearch.push(
        {
          required: tl.type !== 'OPTIONAL',
          searchValuesList: availBaseSearchList
        }
      )
    }

    return {
      availBaseSearchList: availBaseSearchList,
      availGridSearchList: [],
      availLicenceSearchList: availSearch,
      baseMasterGuids: null
    }

  },
  getProductionSearchList: (state) => {
    return state.searchRowList.filter(value => {
      return value.trafficLightId === 0;
    });
  },
  getTrafficLightSearchList: (state) => (trafficLightId) => {
    return state.searchRowList.filter(value => {
      return value.trafficLightId === trafficLightId;
    });
  },
  getTrafficLightType: (state) => (uniqueId) => {
    let tl = state.trafficLights.filter(value => value.uniqueId === uniqueId)[0];
    return tl.type;
  },
  hasProductionRows: (state) => {
    let l = state.searchRowList.filter(value => {
      return value.trafficLightId === 0;
    });
    return l.length > 0;
  },
  getTrafficLights: (state) => {
    return state.trafficLights;
  },
  getTrafficLightCount: (state) => {
    return state.trafficLights.length;
  },
  getSearchRow: (state) => (uniqueId) => {
    return state.searchRowList.filter(value => value.uniqueId === uniqueId)[0];
  },
  isSearchRowEditDisabled: (state) => (uniqueId) => {
    let searchRow = state.searchRowList.filter(value => value.uniqueId === uniqueId)[0];
    if (searchRow.searchOperator === 'IS_EMPTY' || searchRow.searchOperator === 'IS_NOT_EMPTY') {
      return true;
    }
    return false;
  },
  getData: (state) => (uniqueId) => {
    let row = state.searchRowList.filter(value => {
      return value.uniqueId === uniqueId;
    });
    // console.log('sdf: ' + JSON.stringify(row));

    return row[0].data;
  },

  getSearchProfiles: (state) => {
    return state.searchProfiles;
  },
  getActiveProfile: (state) => {
    return state.activeProfile;
  },
  getActiveProfileName: (state) => {
    if (state.activeProfile != null) {
      return state.activeProfile.profileName;
    } else {
      return '';
    }
  },

  searching: (state) => {
    return state.searching;
  },
  multiAvailData: (state) => {
    return state.multiAvailList;
  },
  licences: (state) => {
    return state.licences;
  },
  contracts: (state) => {
    return state.contracts;
  },
  options: (state) => {
    return state.options;
  },
  availDetails: (state) => {
    return state.availDetails;
  },
  getGridFilters: (state) => {
    let res = [];

    for (let prop in state.multiAvailFilters) {
      let value = _.get(state.multiAvailFilters, prop);

      console.log("getGridFilters: ", {prop: prop, value: value})

      if (value instanceof Date) {
        value = value.toLocaleDateString();
      }

      if (value && !_.isEmpty(value)) {

        let operator = 'CONTAINS';
        if (_.has(value, 'key')) {
          value = _.get(value, 'key');
          operator = 'EQUALS';
        }

        res.push(
          {
            fieldName: prop.replace('dynamicFields_', ''),
            operator: operator,
            searchValueList: (value && Array.isArray(value) && value.length>0) ? value.map(row=>{return row.key}) : [value]
          }
        )
      } else {
        console.log("value is empty: ", value);
      }
    }

    return res;
  },
  getCombinedFilters(stat, getters) {
    let res = _.cloneDeep(getters.getAsSearchRequest);
    let baseList = [];
    baseList = baseList.concat(res.availBaseSearchList);
    let gridList = [];
    gridList = gridList.concat(getters.getGridFilters);
    // baseList = baseList.concat(gridList);
    res.availBaseSearchList = baseList;
    res.availGridSearchList = gridList;

    console.log("Combinedfilter:", res);

    return res;
  },


}

const actions = {
  addProductionSearch(context) {
    let searchRow = {id: 1, trafficLightId: 0, searchField: null, searchOperator: null, data: [""]};
    context.commit('addProductionSearch', searchRow);
  },
  removeSearchRow(context, uniqueId) {
    context.commit('removeSearchRow', uniqueId);
  },
  setFieldForSearchRow(context, call) {
    context.commit('setFieldForSearchRow', call);
  },
  setOperatorForSearchRow(context, call) {
    context.commit('setOperatorForSearchRow', call);
  },
  addTrafficLight(context) {
    context.commit('addTrafficLight');
  },
  addSearchRowToTrafficLight(context, trafficLightId) {
    let searchRow = {id: 1, trafficLightId: trafficLightId, searchField: null, searchOperator: null, data: [""]};
    context.commit('addProductionSearch', searchRow);
  },
  setData(context, call) {
    context.commit('setData', call);
  },
  reset(context) {
    context.commit('clearStore');
    // nextTick trickst ein Aktualisierungsproblem aus
    Vue.nextTick(() => {
      context.commit('reset');
    })
  },
  removeTrafficLight(context, uniqueId) {
    context.commit('removeTrafficLight', uniqueId);
  },
  cloneTrafficLight(context, uniqueId) {
    context.commit('cloneTrafficLight', uniqueId);
  },
  setTrafficLightType(context, call) {
    context.commit('setTrafficLightType', call);
  },

  addSearchProfile(context, profileName) {
    let searchProfileContent = {
      uniqueId: context.state.uniqueId,
      searchRowList: context.state.searchRowList,
      trafficLights: context.state.trafficLights
    }

    let searchProfile = {
      fieldName: SEARCH_PROFILE_FIELDNAME,
      profileName: profileName,
      // Konvertiert den ProfileContent zu einem einfachen String
      profileContent: JSON.stringify(searchProfileContent),
    }

    return WizardProfileService.saveProfile(searchProfile).then(r => {
      let savedProfile = r.data;
      context.commit('addSearchProfile', savedProfile);
      return savedProfile;
    })
  },
  updateSearchProfile(context) {
    if (context.state.activeProfile == null) {
      return;
    }
    let searchProfileContent = {
      uniqueId: context.state.uniqueId,
      searchRowList: context.state.searchRowList,
      trafficLights: context.state.trafficLights
    }
    let searchProfile = context.state.activeProfile;
    searchProfile.profileContent = JSON.stringify(searchProfileContent);
    return WizardProfileService.updateProfile(searchProfile).then(r => {
      let savedProfile = r.data;
      return savedProfile;
    })
  },
  loadSearchProfiles(context) {
    WizardProfileService.loadProfilesForField(SEARCH_PROFILE_FIELDNAME).then(r => {
      context.commit('setProfiles', r.data);
    })
  },
  activateSearchProfile(context, searchProfile) {
    let profileData = JSON.parse(searchProfile.profileContent);
    profileData['searchProfile'] = searchProfile;
    context.commit('clearStore');
    Vue.nextTick(() => {
      context.commit('setStoreData', profileData);
    })
  },
  removeProfile(context, profileId) {
    WizardProfileService.deleteProfile(profileId).then(() => {
      context.commit('removeProfile', profileId);
    })
  },
  publishProfile(context, profileId) {
    WizardProfileService.publishProfile(profileId).then(() => {
      context.commit('publishProfile', profileId);
    })
  },
  dePublishProfile(context, profileId) {
    WizardProfileService.dePublishProfile(profileId).then(() => {
      context.commit('dePublishProfile', profileId);
    })
  },

  search(context, page) {
    return new Promise((resolve, reject) => {
      context.commit('startSearching');
      // context.commit('resetSearchData');
      // console.log("PageEventSearch: ", page);

      AvailSearchService.searchMultiAvailPage(context.getters.getCombinedFilters, page).then(r => {
        // AvailSearchService.searchMultiAvailPage(context.getters.getAsSearchRequest, page).then(r => {
        // AvailSearchService.searchMultiAvail(context.getters.getAsSearchRequest).then(r => {
        let data = [];
        for (let row of r.data.content) {
          let obj = objectToFlattenObject(row);
          obj["rawData"] = row;
          data.push(obj);
        }

        context.commit('resetSearchData');
        context.commit('setMultiAvailList', {
          content: data,
          size: r.data.size,
          totalElements: r.data.totalElements,
          totalPages: r.data.totalPages
        });

        context.commit('finishSearching');
        resolve(data);
      }).catch((r) => {
        context.commit('resetSearchData');
        // context.commit('setMultiAvailList', []);
        context.commit('finishSearching');
        reject(r);
      })
    })
  },
  setMultiAvailFilters(context, multiAvailFilters) {
    context.commit('setMultiAvailFilters', multiAvailFilters);
  },
  loadLicences(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('setLicences', []);
      let searchRequest = context.getters.getAsSearchRequest;
      searchRequest.baseMasterGuids = [];
      searchRequest.baseMasterGuids.push('' + id + '');
      AvailSearchService.loadLicences(searchRequest).then(r => {
        context.commit('setLicences', r.data);
        resolve(r.data);
      }).catch((r) => {
        context.commit('setLicences', []);
        reject(r);
      })
    });
  },
  loadContractsStore(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('setContracts', []);
      ContractService.findByProductionId(id).then(r => {
        context.commit('setContracts', r.data);
        resolve(r.data);
      }).catch((r) => {
        context.commit('setContracts', []);
        reject(r);
      })
    })
  },
  loadOptionsStore(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('setOptions', []);
      OptionsService.findByProductionId(id).then(r => {
        context.commit('setOptions', r.data);
        resolve(r.data);
      }).catch((r) => {
        context.commit('setOptions', []);
        reject(r);
      })
    })
  },
  loadAvailDetailsStore(context, id) {
    return new Promise((resolve, reject) => {
      let searchRequest = context.getters.getAsSearchRequest;
      searchRequest.baseMasterGuids = [];
      searchRequest.baseMasterGuids.push('' + id + '');
      AvailSearchService.getDetails(searchRequest).then(r => {
        context.commit('setAvailDetails', r.data);
        resolve(r.data);
      }).catch((r) => {
        context.commit('setAvailDetails', []);
        reject(r);
      })
    })

  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
